import type { QueueEntry } from '../../api/types'

/**
 * Queue records are work, not people. This predicate is the one semantic gate
 * used by every spatial queue projection: only work genuinely waiting for
 * dispatch belongs in the queue presentation.
 */
export function isWaitingEntry(entry: QueueEntry): boolean {
  return entry.status === 'pending' || (entry.status as string) === 'held'
}

